import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const TagInfo = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fill={color}
        d="M5 17.492a.69.69 0 0 1-.542-.259.69.69 0 0 1 .1-.975l6.034-4.925-2.542-1.15a.696.696 0 0 1-.4-.533.706.706 0 0 1 .225-.625l5.692-4.992h-1.984a.69.69 0 0 1-.691-.691.69.69 0 0 1 .691-.692h3.867c.15 0 .283.058.392.15 0 0 .066.058.1.092.1.116.166.275.166.45v3.833a.69.69 0 0 1-.691.692.69.69 0 0 1-.692-.692V4.883L9.617 9.367l2.583 1.166a.691.691 0 0 1 .15 1.167l-6.9 5.633a.685.685 0 0 1-.442.159H5Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill={color} d="M0 0h20v20H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default TagInfo
